/**
 * Created by piotr.pozniak@thebeaverhead.com on 24/09/2021.
 */
import { PLANS } from "../../../../../consts";
import { useCurrentOrganizationStore } from "../../../../../hooks/redux/currentOrganization";
import {
  hasSubscription,
  hasTrialFinished,
} from "../../../helpers/organization";
import { useUserStore } from "../../../../../hooks/redux/user";
import { useAppStore } from "../../../../../hooks/redux/app";

const DISMISS_ID = "upgradePlan";

export function useUpgradePlanAlert() {
  const { currentOrganization } = useCurrentOrganizationStore();
  const { user } = useUserStore();
  const { dismissedAlerts } = useAppStore();

  const subscription = hasSubscription(currentOrganization);
  const trialFinished = hasTrialFinished(currentOrganization);
  // trial may have expired before a free plan was actually applied yet
  const isTrialExpired =
    trialFinished && subscription && subscription.code !== PLANS.free;

  if (
    (subscription && subscription.code !== PLANS.free) ||
    (user.model && !user.model.is_account_verified)
  ) {
    return null;
  }

  // Real status change (not an offer) — always shown, never dismissible.
  if (isTrialExpired) {
    return {
      id: "trialExpired",
      variant: "warning",
      icon: "AlertTriangle",
      title: "Trial expired",
      body: "Upgrade to keep your widgets running at full strength.",
      action: { label: "Upgrade plan", to: "/billing" },
    };
  }

  // Otherwise this is a plain upsell — promo, not a status.
  if (dismissedAlerts.collection.includes(DISMISS_ID)) {
    return null;
  }

  return {
    id: DISMISS_ID,
    variant: "promo",
    icon: "Zap",
    title: "Upgrade your plan",
    body: "Bring your events closer to your audience with more calendars and views.",
    action: { label: "Upgrade plan", to: "/billing" },
    dismissible: true,
  };
}

export default useUpgradePlanAlert;
